
import { Input } from 'components'
import { Dialog2 } from 'components/Dialog2'

export const EditPONumberDialog = ({ attrs: { meeting, loading } }) => {
  loading = false
  const formData = {
    poNumber: meeting.poNumber
  }

  return {
    view ({ attrs: { meeting, loading, open, onsubmit } }) {
      return m(Dialog2, {
        open,
        save () {
          loading = true
          meeting.poNumber = formData.poNumber
          onsubmit()
        },
        heading: 'Edit PO Number',
        saving: loading
      }, [
        m('.flex.flex-col.gap-3', [
          m(Input, {
            label: 'PO Number',
            value: formData.poNumber,
            type: 'text',
            oninput (value) {
              formData.poNumber = value
            }
          })
        ])
      ])
    }
  }
}
